import type { AdminUserDetail, PermissionDefinition, PermissionProfile } from './types';

const actor = '00000000-0000-4000-8000-000000000001';

export const permissionFixtures: readonly PermissionDefinition[] = Object.freeze([
  Object.freeze({
    code: 'MEMBER_VIEW',
    description: 'View members',
    sensitive: false,
    delegable: true,
  }),
  Object.freeze({
    code: 'MEMBER_MANAGE',
    description: 'Manage members',
    sensitive: true,
    delegable: true,
  }),
  Object.freeze({
    code: 'TRANSACTION_VIEW',
    description: 'View transactions',
    sensitive: false,
    delegable: true,
  }),
  Object.freeze({
    code: 'WALLET_VIEW',
    description: 'View wallets',
    sensitive: true,
    delegable: true,
  }),
  Object.freeze({
    code: 'AUDIT_VIEW',
    description: 'View audit evidence',
    sensitive: true,
    delegable: false,
  }),
]);

export const permissionProfileFixtures: readonly PermissionProfile[] = Object.freeze([
  Object.freeze({
    id: '00000000-0000-4000-8000-000000000901',
    partnerId: '00000000-0000-4000-8000-000000000101',
    agentId: '00000000-0000-4000-8000-000000000401',
    name: 'Agent operations',
    status: 'ACTIVE',
    permissions: ['MEMBER_VIEW', 'TRANSACTION_VIEW'],
    assignedUserCount: 3,
    createdAt: '2026-07-20T10:00:00+07:00',
    createdBy: actor,
    updatedAt: '2026-07-22T12:00:00+07:00',
    updatedBy: actor,
  }),
]);

export const adminUserFixtures: readonly AdminUserDetail[] = Object.freeze([
  Object.freeze({
    id: actor,
    subject: 'mock-super-admin',
    username: 'mock-super-admin',
    email: 'mock.super.admin@example.test',
    displayName: 'Mock Super Admin',
    role: 'SUPER_ADMIN',
    status: 'ACTIVE',
    partnerId: null,
    agentId: null,
    permissionProfile: null,
    lastLoginAt: '2026-07-22T10:00:00+07:00',
    createdAt: '2026-07-20T10:00:00+07:00',
    createdBy: actor,
    updatedAt: '2026-07-22T12:00:00+07:00',
    updatedBy: actor,
  }),
  Object.freeze({
    id: '00000000-0000-4000-8000-000000000003',
    subject: 'agent-admin-subject',
    username: 'agent-admin',
    email: 'agent.admin@example.test',
    displayName: 'Agent Admin',
    role: 'AGENT_ADMIN_USER',
    status: 'ACTIVE',
    partnerId: '00000000-0000-4000-8000-000000000101',
    agentId: '00000000-0000-4000-8000-000000000401',
    permissionProfile: Object.freeze({
      id: permissionProfileFixtures[0]!.id,
      name: permissionProfileFixtures[0]!.name,
      status: permissionProfileFixtures[0]!.status,
    }),
    lastLoginAt: null,
    createdAt: '2026-07-21T10:00:00+07:00',
    createdBy: actor,
    updatedAt: '2026-07-22T12:00:00+07:00',
    updatedBy: actor,
  }),
]);
